import { isEmpty } from 'lodash'
import { TAccountWithRoles } from 'types/accounts'

export const filterAccountsByStatus = (
  status: string,
  allAccountsWithRole: TAccountWithRoles[]
) => {
  return isEmpty(status) || status === 'all'
    ? allAccountsWithRole
    : allAccountsWithRole?.filter((account: TAccountWithRoles) => account?.accountStatus === status)
}
